import { useEffect, useState } from "react";
import "./Testeroni.css";

const HelloParagraph = ({s}: {s: string}) =>
    <div>
        <h2>{s}</h2>
        <p>{s + "there!"}</p>
    </div>;

// export const Testeroni = ({ isLoading, ...props }: { isLoading: boolean, className: string }) => {
//     const [myList, setMyList] = useState([] as string[]);
//     const [myString, setMyString] = useState("");

//     const addToList = () => {
//         setMyList([...myList, myString]);
//     }

//     // useEffect(() => {
//     //     fetch(asd)
//     // }, []);



//     if(isLoading) return <p>loading...</p>;

//     return (
//         <div>
//             <h1>Hi there!</h1>
//             <p>General Kenobi!</p>

//             <input type="text" onChange={e => setMyString(e.target.value)} value={myString} />
//             <button onClick={(e) => addToList()}>Add some hello text</button>

//             {myList.map(s => 
//                 <HelloParagraph s={s + " There!"}/>
//                 )}
//         </div>
//     );
// }

interface DogApiResponse {
    message: string;
    status: string;
}

const MyInput = ({ value, setValue }: any) =>
    <input type="text" onChange={e => setValue(e.target.value)} value={value} />;

const DogPicture = ({ breed, change }: { breed: string, change: boolean }) => {
    const [url, setUrl] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    
    useEffect(() => {
        const myFunc = async () => {
            const response = await fetch(`https://dog.ceo/api/breed/${breed}/images/random`);
            const data = await response.json() as DogApiResponse;
            
            console.table(data);
            
            setUrl(data.message);
            setIsLoading(false);
        }
        
        myFunc();
    }, [change]);
        
    if(isLoading) return <p>Loading...</p>
    
    return (
        <div className="img-wrapper">
            <img src={url} alt="Dog picture"/>
            <h2>{breed}</h2>
        </div>
    );
}

export const Testeroni = ({ random }: { random: any }) => {
    const [breed, setBreed] = useState("");
    const [breeds, setBreeds] = useState([] as string[]);
    const [isLoading, setIsLoading] = useState(true);
    const [change, setChange] = useState(true);
    
    useEffect(() => {
        const myFunc = async () => {
            const response = await fetch(`https://dog.ceo/api/breeds/list/all`);
            const data = await response.json();
            
            setBreeds(Object.keys(data.message));
            setIsLoading(false);
        }
        
        myFunc();
    }, [change]);
        
    if(isLoading) return <p>Loading...</p>
    return (
        <div className="testeroni">
            <div className="list-wrapper">
            {breeds.map(breed =>
                <div className="list-elem">
                    <p>{breed}</p>
                    <button onClick={e => {setBreed(breed); setChange(!change); return null;}}>GIMMI MORE</button>
                </div>
                )}
            </div>
            <DogPicture breed={breed} change={change} />
        </div>
    );
}
